import { useAuth } from '../contexts/AuthContext'

/**
 * Is this account a manager, or a driver?
 *
 * Used ONLY to decide what to show. Every restriction it implies is
 * enforced by the API as well — hiding a tile stops an honest person
 * wandering into the profit report, it does not stop a determined one
 * typing the URL.
 */
export function useIsManager(): boolean {
  return useAuth().user?.role === 'admin'
}
